{
  "continue_to_resolve_errors": "Verder naar fouten oplossen",
  "correction_blocked": {
    "first_entry_has_errors": "Uit de eerste invoer blijkt dat er waarschijnlijk fouten in het papieren proces-verbaal zijn gemaakt. Daarom kan je de tweede invoer nu niet laten herstellen door de oorspronkelijke invoerder. Eerst moet het papieren proces-verbaal worden gecontroleerd. Dat doen we in de volgende stap. De tweede invoer wordt verwijderd.",
    "first_entry_imported": "De eerste invoer is geïmporteerd uit een tellingsbestand. Afwijkingen met het papieren proces-verbaal kunnen daarin niet worden hersteld. Er is tweede handmatige invoer nodig vanaf het papieren proces-verbaal.",
    "second_entry_has_errors": "Uit de tweede invoer blijkt dat er waarschijnlijk fouten in het papieren proces-verbaal zijn gemaakt. Daarom kan je de eerste invoer nu niet laten herstellen door de oorspronkelijke invoerder. Eerst moet het papieren proces-verbaal worden gecontroleerd. Dat doen we in de volgende stap. De eerste invoer wordt verwijderd."
  },
  "form_content": "De resultaten van dit stembureau zijn pas definitief als er twee gelijke invoeren zijn. Kies de invoer die overeenkomt met het papieren proces-verbaal.",
  "form_question": "Welke invoer klopt?",
  "headers": {
    "description": "Omschrijving",
    "field": "Veld",
    "first_entry": "Eerste invoer",
    "second_entry": "Tweede invoer"
  },
  "imported_from_file": "geïmporteerd uit tellingsbestand",
  "options": {
    "discard_both": "Geen van beide: alles opnieuw invoeren",
    "keep_first_and_discard_second": "Eerste invoer ({name})",
    "keep_second_and_discard_first": "Tweede invoer ({name})"
  },
  "page_content": "De eerste en tweede invoer zijn niet gelijk. Controleer welke invoer precies overeenkomt met het papieren proces-verbaal. Je ziet hieronder alleen de verschillen tussen invoer 1 en 2.",
  "page_title": "Verschillen oplossen",
  "required_error": "Dit is een verplichte vraag. Maak een keuze uit de opties hieronder.",
  "section": "Rubriek",
  "title": "Verschil tussen eerste en tweede invoer",
  "wrong_entry_options": {
    "correct": "Verschillen laten herstellen door de oorspronkelijke invoerder",
    "discard": "Hele proces-verbaal opnieuw laten invoeren"
  },
  "wrong_entry_question": "Wat wil je doen met de invoer die <u>niet</u> klopt?"
}
